<template>
  <div class="card" :style="style.width + style.height">
    <h1 class="user-active-title">
      {{ title }}
    </h1>
    <div class="box-details">
      <div class="box-second-row">
        <font-awesome-icon size="lg" :color="data.icon.color" :icon="data.icon.type" />
        <h1 class="data-qt">
          {{ data.qt.toLocaleString('pt-BR') }}
        </h1>
      </div>
      <div v-if="!hideSubtitle" class="box-thirt-row">
        <span>{{ subtitle }}</span>
        <span :style="{ color: data.percentcolor }">{{ data.percent }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	mixins: [global],
	props: {
		hideSubtitle: {
			type: Boolean,
			default: false,
		},
		width: {
			type: String,
			default: '100%',
		},
		height: {
			type: String,
			default: '100%',
		},
		data: {
			type: Object,
			default: () => {},
		},
		title: {
			type: String,
			default: 'Titulo',
		},
		subtitle: {
			type: String,
			default: 'Subtitulo',
		},
	},
	computed: {
		style() {
			const styledata = {
				width: `width:${this.width};`,
			};
			return styledata;
		},
	},
};
</script>

<style lang="scss" scoped>
.card {
	display: flex;
	padding: 20px;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
}
.box-thirt-row {
	display: flex;
	justify-content: space-between;
	font-size: 12px;
	color: #242f48;
}
.box-second-row {
	display: flex;
	justify-content: space-between;
	margin-bottom: 8px;
	color: #242f48;
}
.user-active-title {
	font-weight: 700;
	color: #242f48;
	font-size: 14px;
	text-transform: uppercase;
	margin-bottom: 16px;
}
.data-qt {
	font-size: 26px;
	font-weight: 500;
}
.box-details {
	display: flex;
	flex-direction: column;
	/*     justify-content: center;
    align-items: center; */
}
.percent-box {
	display: flex;
	align-items: center;
	padding-right: 10px;
	padding-left: 10px;
	border-radius: 10px;
}
.percent-box h1 {
	margin-left: 10px;
}
</style>
